export const EXPERIENCE_SECTION_DISPLAY_WEB_PAGE_PATHS = {
  TOP: '/',
  EXPERIENCES: '/experiences',
  EXPERIENCE_DETAIL: '/experiences/id',
  DONE_RESERVATION: '/experiences/id/done-reservation',
  STORY_DETAIL: '/stories/id',
  CANCELLATION_COMPLETE: '/cancellation/complete',
  AREA_DETAIL: '/areas/id',
  ITINERARY_DETAIL: '/itineraries/id',
};

export const PICKUP_WEB_SECTION_ID = 'pick-up';

/** トップページ Experiential Stays セクションのバックエンド体験セクション識別子 */
export const CURATED_STAYS_WEB_SECTION_ID = 'Curated_Stays';
